import Image from 'next/image';
import Link from 'next/link';

import styles from '@/components/agents/agents.module.css';

import clsxm from '@/lib/clsxm';

import { ArrowGlyph, Stage } from '@/components/agents/primitives';

import { scrollToSection, WORKSHOP_CONTACT_ID } from '@/utils/scrollToSection';

import { PHOTOS } from './kit';

export default function WorkshopsFinalCta() {
  return (
    <section className='mx-auto max-w-7xl px-3 pb-24 pt-8 sm:px-6 sm:pb-32 lg:px-8'>
      <Stage
        variant='indigo'
        halftoneAt='100% 100%'
        className='px-6 py-16 sm:px-14 sm:py-24'
      >
        <div className='relative grid items-center gap-14 lg:grid-cols-[1.7fr_1fr]'>
          <div>
            <h2
              className={clsxm(
                styles.display,
                'text-[2.25rem] font-semibold leading-[1.06] text-white sm:text-5xl lg:text-[3.5rem]',
              )}
            >
              Bring AI to your team.
            </h2>
            <p className='mt-6 max-w-lg text-lg leading-8 text-primary-100'>
              Tell us about your team and we’ll plan a hands-on session around
              the work you do every day.
            </p>
            <div className='mt-10 flex flex-wrap items-center gap-3'>
              <a
                href={`#${WORKSHOP_CONTACT_ID}`}
                onClick={scrollToSection}
                className='inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3.5 text-[15px] font-semibold text-primary-700 shadow-[0_10px_30px_-10px_rgba(20,10,80,0.6)] transition-colors duration-200 hover:bg-primary-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white'
              >
                Plan a workshop
                <ArrowGlyph />
              </a>
              <Link
                href='/contact'
                className='inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-[15px] font-semibold text-white ring-1 ring-inset ring-white/35 transition duration-200 hover:bg-white/10 hover:ring-white/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white'
              >
                Contact us
              </Link>
            </div>
          </div>

          <div aria-hidden='true' className='hidden justify-center lg:flex'>
            <div className={clsxm(styles.float, 'relative h-64 w-64')}>
              <span className='absolute inset-6 rounded-full bg-white/15 blur-2xl' />
              <Image
                src={PHOTOS.marky}
                alt=''
                fill
                unoptimized
                className='object-contain drop-shadow-[0_24px_40px_rgba(20,10,80,0.45)]'
              />
            </div>
          </div>
        </div>
      </Stage>
    </section>
  );
}
